import { v4 as uuidv4 } from 'uuid';

import type { AssetsDrawingSchema } from '@iconik-io/iconik-api/src/services/assets';
import type { FilesResolutionType } from '@iconik-io/iconik-api/src/services/files';
import type {
  Annotation,
  AnnotationElement,
} from '@iconik-io/unified-player-core';

import { DRAWING_VERSION_LEGACY } from './annotation_versions';

export function createUnifiedAnnotation(
  drawing: AssetsDrawingSchema,
  resolution: FilesResolutionType | undefined,
): Annotation | undefined {
  let width = 1;
  let height = 1;

  if (!drawing.version || drawing.version === DRAWING_VERSION_LEGACY) {
    width = resolution?.width ?? 0;
    height = resolution?.height ?? 0;
    if (!width || !height) {
      return undefined;
    }
  }

  const primitives = drawing.primitives;

  const result: Annotation = {};

  for (const primitive of primitives ?? []) {
    const points = primitive.points?.map((point) => ({
      x: point.x / width,
      y: point.y / height,
    }));
    if (!points) {
      continue;
    }
    const annotationElement: AnnotationElement = {
      type: primitive.type,
      points,
      options: {
        color: primitive.color ?? '#000000',
        width: primitive.width ?? 8 / 1000,
        opacity: primitive.opacity ?? 1,
        text: primitive.text,
      },
    };
    result[uuidv4()] = annotationElement;
  }

  return result;
}
